export default __webpack_public_path__ + "static/logo-traced-38915357b9540bbbf7a1fa0982776e69.svg";